import { Reveal } from "../components/Reveal";

export const Ethics = () => (
  <section className="bg-white border-y border-line" data-testid="ethics-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 lg:py-20 text-center">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">Our medical position</p>
        <div className="mt-7 space-y-5 text-inkmuted leading-relaxed text-[15px]">
          <p className="font-serif text-2xl text-forest">InSight Metabolics is a medical practice.</p>
          <p>
            Our approach is complementary to appropriate conventional medical care. We do not recommend stopping
            prescribed medication without appropriate medical supervision.
          </p>
          <p>
            Individual results vary. Recommendations are personalised according to medical history, examination,
            investigations and clinical needs.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
